export default "__VITE_ASSET__rKexwn3D__"